<!--
  Иконка паспорта: вертикальный документ с текстовыми строками.
  Обычно используется в блоках паспортных данных водителя.
-->
<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <rect
      x="6"
      y="3"
      width="12"
      height="18"
      rx="2"
      :stroke="stroke"
      stroke-width="2"
    />
    <path
      d="M9 8H15M9 12H15M9 16H13"
      :stroke="stroke"
      stroke-width="2"
      stroke-linecap="round"
    />
  </svg>
</template>

<script>
export default {
  name: "PassportIcon",

  props: {
    size: {
      type: [Number, String],
      default: 20,
    },
    stroke: {
      type: String,
      default: "currentColor",
    },
  },
};
</script>
